<div class="dashboard-container">
    <app-sidebar-user *ngIf="!isCompanyLoggedIn"></app-sidebar-user>
    <app-sidebar *ngIf="isCompanyLoggedIn"></app-sidebar>
    <app-mobile-header></app-mobile-header>

    <div class = "dashboard-profile-iamge">
        <a routerLink="/dashboard/company/settings">
            <img *ngIf="image" [src]="currentProfileImageUrl" class = "profile_image" alt="Profile Picture">
        </a>
    </div>

    <div class="dashboard-content">
        <router-outlet></router-outlet>
    </div>

</div>